/* eslint-disable security/detect-unsafe-regex */
// NOTE: we don't have full RFC2822 email regex, we are keeping this in sync with our BE validation
export const EMAIL_PATTERN =
  /^[\'_a-zA-Z0-9-]+(\.[\'_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-z]{2,20})$/gi
export const NPI_NUMBER_PATTERN = /^\d{10}$/
export const PHONE_NUMBER_PATTERN = /^\+1\s\d{3}-\d{3}-\d{4}$/
export const SSN_NUMBER_PATTERN = /^\d{3}-\d{2}-\d{4}$/
export const ZIP_CODE_PATTERN = /^\d{5}$|^$/
